import {gsap} from "gsap/gsap-core";
import {useLayoutEffect, useState} from "preact/hooks";
import {Capturing} from "@game/ui/components/Capturing/Capturing";

export const CapturingAnimated = ({
    from,
    to,
    total,
    startDelay = 1,
    onAnimationComplete
}: {
    startDelay?: number;
    from: number;
    to: number;
    total: number;
    onAnimationComplete?: (...args: any[]) => void | null;
}) => {
    const [state, setState] = useState({captured: from / total, showGift: false});
    useLayoutEffect(() => {
        const obj = {value: from / total};
        gsap.fromTo(obj, obj, {
            delay: startDelay,
            duration: 1,
            value: to / total,
            ease: "sine.in",
            onUpdate: () => {
                setState({captured: obj.value, showGift: false});
            },
            onComplete: onAnimationComplete
        });
    }, [from, to]);
    return <Capturing captured={state.captured} stages={total} showGift={state.showGift} />;
};
